exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rating-stars {\n  color: #d17581; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./modules/rating/css/ratings.scss
// module id = 523
// module chunks = 0